import { httpRequest, BASE_URL } from "./api-shared"
import { userInfo, registerUserInfo } from "./dataTypes";

const USER_URL = "user"

export const addUserApi = (userInfo: registerUserInfo):
  Promise<userInfo> => {
  return httpRequest(`${BASE_URL}/${USER_URL}`,
    'post', userInfo
  ).then(r => {
    if (r.success === true && r.data) {
      return r.data as userInfo;
    } else {
      console.log("Error Adding User " + userInfo.email + ", cause: " + JSON.stringify(r.error));
      throw (r.error);
    }
  });
};

export const editUserApi = (userInfo: userInfo): Promise<userInfo> => {
  return httpRequest(`${BASE_URL}/${USER_URL}`,
    'put', userInfo
  ).then(res => {
    if (res.success === true && res.data) {
      return res.data as userInfo;
    } else {
      console.log(res.error);
      throw (res.error);
    }
  });
};

export const deleteUserApi = (userInfo: userInfo):
  Promise<boolean> => {
  return httpRequest(`${BASE_URL}/${USER_URL}`,
    'delete', userInfo
  ).then(r => {
    if (r.success === true) {
      return r.success;
    } else {
      console.log("Error Deleting User " + userInfo.email + ", cause: " + r.error!.message);
      throw (r.error);
    }
  });
};


export const getUsersApi = () => {
  let url: string = `${BASE_URL}/${USER_URL}`;

  return httpRequest(url,
    'get'
  ).then(result => {
    if (result.success && result.data) {
      return result.data as userInfo[];
    } else {
      console.log(result.error!.message);
      throw result.error;
    }
  });
};